export type CqvVtmeLoadReason = 'initial' | 'filter' | 'refresh' | 'tab' | 'fresh';

export interface CqvVtmeCardPublishInput {
  reason: CqvVtmeLoadReason;
  /** A fila desta query foi pedida. */
  expectList: boolean;
  /** O relatório desta query foi pedido. */
  expectReport: boolean;
  /** O GET da lista assentou (sucesso ou erro). */
  listSettled: boolean;
  /** O GET do relatório assentou (sucesso ou erro). */
  reportSettled: boolean;
}

export interface CqvVtmeCardPublishDecision {
  /** Skeleton continua. Não escrever lista nem relatório visíveis. */
  hold: boolean;
  publishList: boolean;
  publishReport: boolean;
}

/** Filtro e primeira carga só pintam os cartões quando lista e relatório da mesma query assentaram. */
export function shouldHoldCqvVtmeCardsUntilBothSettle(reason: CqvVtmeLoadReason): boolean {
  return reason === 'filter' || reason === 'initial' || reason === 'fresh';
}

/**
 * No filtro, a lista não pode aparecer sozinha: o SLA antigo ficaria ao lado dos totais novos.
 * Refresh e troca de aba publicam cada resposta quando chega, sem esconder os números atuais.
 */
export function decideCqvVtmeCardPublish(input: CqvVtmeCardPublishInput): CqvVtmeCardPublishDecision {
  const waitingForPair = shouldHoldCqvVtmeCardsUntilBothSettle(input.reason);
  const listReady = !input.expectList || input.listSettled;
  const reportReady = !input.expectReport || input.reportSettled;

  if (waitingForPair && (!listReady || !reportReady)) {
    return { hold: true, publishList: false, publishReport: false };
  }

  return {
    hold: false,
    publishList: input.expectList && input.listSettled,
    publishReport: input.expectReport && input.reportSettled,
  };
}
